export const COMPANY = "Regina Expert Locksmith";
export const PHONE_DISPLAY = "306-262-5995";
export const PHONE_TEL = "tel:+13062625995";
export const EMAIL = "reginaexpertlocksmith@gmail.com";
export const EMAIL_MAILTO = "mailto:reginaexpertlocksmith@gmail.com";

export const SERVICE_AREAS = ["Regina", "White City", "Emerald Park", "Pilot Butte", "Balgonie"];

export const NAV_LINKS = [
    { id: "services", label: "Services" },
    { id: "why-us", label: "Why Us" },
    { id: "how-it-works", label: "How It Works" },
    { id: "service-area", label: "Service Area" },
    { id: "about", label: "About" },
    { id: "faq", label: "FAQ" },
];

export const SERVICE_TYPES = [
    "Residential Locksmith",
    "Commercial Locksmith",
    "Automotive Locksmith",
    "Emergency Locksmith",
    "Other / Not Sure",
];

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1562259929-b4e1fd3aef09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxsb2Nrc21pdGglMjBrZXklMjByZXBhaXIlMjBob3VzZSUyMGRvb3IlMjBzZWN1cml0eSUyMGxvY2t8ZW58MHx8fHwxNzg4ODM0MzM2fDA&ixlib=rb-4.1.0&q=85",
    residential: "https://images.unsplash.com/flagged/photo-1564767609342-620cb19b2357?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxsb2Nrc21pdGglMjBrZXklMjByZXBhaXIlMjBob3VzZSUyMGRvb3IlMjBzZWN1cml0eSUyMGxvY2t8ZW58MHx8fHwxNzg4ODM0MzM2fDA&ixlib=rb-4.1.0&q=85",
    commercial: "https://images.unsplash.com/photo-1585914641050-fa9883c4e21c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxsb2Nrc21pdGglMjBrZXklMjByZXBhaXIlMjBob3VzZSUyMGRvb3IlMjBzZWN1cml0eSUyMGxvY2t8ZW58MHx8fHwxNzg4ODM0MzM2fDA&ixlib=rb-4.1.0&q=85",
    automotive: "https://images.unsplash.com/photo-1653565217811-85b41bcd1edb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHszfHxjYXIlMjBrZXklMjBhdXRvbW90aXZlJTIwdmVoaWNsZSUyMGRvb3IlMjBsb2NrJTIwdGVjaG5pY2lhbnxlbnwwfHx8fDE3ODg4MzQzNDN8MA&ixlib=rb-4.1.0&q=85",
    emergency: "https://images.unsplash.com/flagged/photo-1564767609213-c75ee685263a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxsb2Nrc21pdGglMjBrZXklMjByZXBhaXIlMjBob3VzZSUyMGRvb3IlMjBzZWN1cml0eSUyMGxvY2t8ZW58MHx8fHwxNzg4ODM0MzM2fDA&ixlib=rb-4.1.0&q=85",
    about: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=1200&q=75",
};

export const BTN_GOLD =
    "inline-flex items-center justify-center gap-2.5 rounded-full bg-gold px-7 py-4 text-sm font-extrabold uppercase tracking-wider text-navy-950 shadow-lg shadow-gold/25 transition-[transform,background-color,box-shadow] duration-300 hover:-translate-y-0.5 hover:bg-gold-light hover:text-navy-950";

export const BTN_OUTLINE_LIGHT =
    "inline-flex items-center justify-center gap-2.5 rounded-full border border-white/30 px-7 py-4 text-sm font-bold uppercase tracking-wider text-white transition-[transform,background-color,border-color,color] duration-300 hover:-translate-y-0.5 hover:border-white hover:bg-white hover:text-navy-950";

export const BTN_NAVY =
    "inline-flex items-center justify-center gap-2.5 rounded-full bg-navy-950 px-7 py-4 text-sm font-extrabold uppercase tracking-wider text-white transition-[transform,background-color,color] duration-300 hover:-translate-y-0.5 hover:bg-gold hover:text-navy-950";

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
